<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'App',
  mounted() {
    // 移动端视口高度修正
    const setVH = () => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
    
    setVH()
    window.addEventListener('resize', setVH)
    window.addEventListener('orientationchange', setVH)
    
    // 初始化主题
    this.initTheme()
  },
  methods: {
    ...mapActions('app', ['setTheme']),
    initTheme() {
      const savedTheme = localStorage.getItem('theme') || 'dark'
      this.setTheme(savedTheme)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh; /* 回退方案 */
  height: calc(var(--vh, 1vh) * 100); /* 移动端视口高度修正 */
  margin: 0;
  padding: 0;
  overflow-x: hidden; /* 防止水平滚动 */
}

html {
  font-size: 16px; /* 基础字体大小 */
  touch-action: manipulation; /* 优化移动端点击延迟 */
  -webkit-tap-highlight-color: transparent; /* 移除移动端点击高亮 */
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
  min-width: 320px; /* 最小宽度 */
  line-height: 1.4;
  overflow-x: hidden;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* 路由切换动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--transition-duration) var(--transition-function);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Element UI 暗色主题适配 */
.el-message-box {
  background: var(--bg-overlay) !important;
  border: 1px solid var(--border-color) !important;
  backdrop-filter: blur(10px);
}

.el-message-box__title,
.el-message-box__message {
  color: var(--text-color) !important;
}

.el-message {
  background: var(--bg-overlay) !important;
  border: 1px solid var(--border-color) !important;
  backdrop-filter: blur(10px);
}

.el-loading-mask {
  background: var(--bg-overlay) !important;
  backdrop-filter: blur(5px);
}

.el-table {
  background: transparent !important;
  color: var(--text-color) !important;
}

.el-table th,
.el-table tr {
  background: transparent !important;
}

.el-table--border::after,
.el-table--group::after {
  background-color: var(--border-color) !important;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid var(--border-color) !important;
}

.el-table--border td,
.el-table--border th {
  border-right: 1px solid var(--border-color) !important;
}

.el-pagination {
  color: var(--text-color) !important;
}

.el-pagination button:disabled {
  background: transparent !important;
}

.el-select-dropdown,
.el-dropdown-menu {
  background: var(--bg-overlay) !important;
  border: 1px solid var(--border-color) !important;
  backdrop-filter: blur(10px);
}

.el-select-dropdown__item,
.el-dropdown-menu__item {
  color: var(--text-color) !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover,
.el-dropdown-menu__item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.el-input__inner,
.el-textarea__inner {
  background: rgba(0, 0, 0, 0.2) !important;
  border: 1px solid var(--border-color) !important;
  color: var(--text-color) !important;
}

.el-input__inner:hover,
.el-textarea__inner:hover {
  border-color: var(--border-color-light) !important;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

.el-tabs__item {
  color: var(--text-color-secondary) !important;
}

.el-tabs__item.is-active {
  color: var(--primary-color) !important;
}

.el-tabs__active-bar {
  background-color: var(--primary-color) !important;
}

/* 移动端媒体查询 */
@media screen and (max-width: 768px) {
  html {
    font-size: 14px; /* 移动端基础字体调整 */
  }
  
  /* Element UI 移动端适配 */
  .el-message {
    min-width: 300px !important;
    width: 90% !important;
  }
  
  .el-message-box {
    width: 90% !important;
  }
  
  .el-dialog {
    width: 90% !important;
    margin: 10vh auto !important;
  }
  
  .el-form-item {
    margin-bottom: 15px !important;
  }
  
  .el-table {
    width: 100% !important;
    font-size: 12px !important;
  }
  
  .el-pagination {
    white-space: normal !important;
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 5px !important;
  }
}

/* 横屏适配 */
@media screen and (orientation: landscape) and (max-height: 500px) {
  #app {
    height: auto;
    min-height: 100vh;
  }
}
</style>
